import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0590b609"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column-main-container" }
const _hoisted_2 = { class: "left-column-list" }
const _hoisted_3 = {
  key: 0,
  class: "function-button-group"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建文章")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = { class: "right-column-content" }
const _hoisted_8 = { class: "column-info" }
const _hoisted_9 = { style: {"width":"100%"} }

import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import { computed, onMounted, ref } from "vue";
import apis from "@/api";
import api from "@/api";
import type { Article } from "@/api/article";
import ArticleInfo from "@/views/common/ArticleInfo.vue";
import { transferArrayToTree } from "@/api/catelog";
import type { Cate, Tree } from "@/api/catelog";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const isOwner = computed(() => store.state.common.isOwner);

const router = useRouter();
const route = useRoute();

const cateList = ref<Array<Cate>>([]);

const cateTree = ref<Array<Tree>>([]);

const currentCate = ref<Cate>({ type: 1 });
const selectCate = ref<Cate>({});

const currentArticleList = ref<Array<Article>>([]);

onMounted(() => {
  getList();
});

const expandedKeys = ref<string[]>([]);

function edit(key: number) {
  getCurrentCateById(key);
  addModalVisible.value = true;
}
function deleteCate(key: number) {
  api.catelog.deleteCate.request({ id: key });
  getList();
}

function getList() {
  api.catelog.selectCateList.request<Array<Cate>>({ type: 1 }).then((res) => {
    if (res.data) {
      cateList.value = res.data;
      cateTree.value = transferArrayToTree(res.data);
      if (!selectCate.value.name) {
        selectCate.value = res.data[0];
        getArticleByCate(selectCate.value.id ?? -1);
      }
    }
  });
}

function toWritePage() {
  router.push({ name: "Write", params: { redirect: route.path } });
}

function selectTreeNode(selectedKeys: any, data: { selected: boolean; selectedNodes: any; node: any; event: any }) {
  getArticleByCate(data.node.eventKey);
  getCateById(data.node.eventKey);
}

function getArticleByCate(id: number) {
  api.article.getArticleByCate.request<Array<Article>>({ id: id }).then((res) => {
    if (res.data) currentArticleList.value = res.data;
  });
}

function getCateById(id: number) {
  api.catelog.selectCateById.request<Cate>({ id: id }).then((res) => {
    if (res.data) selectCate.value = res.data;
  });
}

function getCurrentCateById(id: number) {
  api.catelog.selectCateById.request<Cate>({ id: id }).then((res) => {
    if (res.data) currentCate.value = res.data;
  });
}

const addModalVisible = ref(false);
const confirmLoading = ref<boolean>(false);

function showAdd() {
  currentCate.value = { type: 1 };
  addModalVisible.value = true;
}

function handleOk() {
  // console.log(currentCate.value);
  currentCate.value.createTime = undefined;
  currentCate.value.updateTime = undefined;
  currentCate.value.children = undefined;
  // 校验
  api.catelog.saveOrUpdateCate.request<Cate>(currentCate.value).then((res) => {
    // console.log(res);
    getList();
    addModalVisible.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(isOwner))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_a_button, { onClick: toWritePage }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { name: "write" }),
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_svg_icon, {
              name: "setup",
              style: {"font-size":"30px"},
              onClick: showAdd
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_tree, {
        "tree-data": cateTree.value,
        expandedKeys: expandedKeys.value,
        "onUpdate:expandedKeys": _cache[0] || (_cache[0] = ($event: any) => ((expandedKeys).value = $event)),
        onSelect: selectTreeNode
      }, _createSlots({ _: 2 }, [
        (_unref(isOwner))
          ? {
              name: "title",
              fn: _withCtx(({ key: treeKey, title }) => [
                _createVNode(_component_a_dropdown, { trigger: ['contextmenu'] }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, {
                          key: "1",
                          onClick: ($event: any) => (edit(treeKey))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_a_menu_item, {
                          key: "2",
                          onClick: ($event: any) => (deleteCate(treeKey))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(title), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            }
          : undefined
      ]), 1032, ["tree-data", "expandedKeys"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(selectCate.value.name) + "(" + _toDisplayString(selectCate.value.description) + ")", 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentArticleList.value, (article) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(ArticleInfo, { article: article }, null, 8, ["article"])
        ]))
      }), 256))
    ]),
    _createVNode(_component_a_modal, {
      visible: addModalVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((addModalVisible).value = $event)),
      title: "添加专栏",
      "confirm-loading": confirmLoading.value,
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tree_select, {
          value: currentCate.value.parentId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((currentCate.value.parentId) = $event)),
          "show-search": "",
          style: {"width":"100%"},
          "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
          placeholder: "Please select",
          "allow-clear": "",
          "tree-default-expand-all": "",
          "tree-data": cateTree.value
        }, {
          title: _withCtx(({ value: val, title }) => [
            _createTextVNode(_toDisplayString(title), 1)
          ]),
          _: 1
        }, 8, ["value", "tree-data"]),
        _createVNode(_component_a_input, {
          value: currentCate.value.name,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((currentCate.value.name) = $event)),
          placeholder: "专栏名"
        }, null, 8, ["value"]),
        _createVNode(_component_a_input, {
          value: currentCate.value.description,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((currentCate.value.description) = $event)),
          placeholder: "描述"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"])
  ]))
}
}

})